import React from 'react'
import { Outlet } from 'react-router-dom'
import { DollarSign, Shield, Zap, Lock } from 'lucide-react'
import { useTheme } from '../../context/ThemeContext'

// NEW CODE:
const AuthLayout = ({ adminPortal = false }) => {
  const { isDark } = useTheme()

  const features = [
    {
      icon: Shield,
      title: 'Secure Banking',
      description: 'Bank-level security with end-to-end encryption'
    },
    {
      icon: Zap,
      title: 'Instant Transactions',
      description: 'Process deposits and withdrawals in real-time'
    },
    {
      icon: Lock,
      title: 'Admin Approval',
      description: 'All transactions verified by administrators'
    }
  ]

  return (
    <div className="min-h-screen flex">
      {/* Left side - Branding & Features (hidden on mobile) */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary-600 to-primary-800 p-12 flex-col justify-between">
        <div>
          {/* Logo */}
          <div className="flex items-center gap-3 text-white mb-16">
            <div className="w-12 h-12 bg-white/10 backdrop-blur rounded-xl flex items-center justify-center">
              <DollarSign className="w-7 h-7" />
            </div>
            <div>
              <h1 className="text-2xl font-bold">SecureBank</h1>
              <p className="text-primary-200 text-sm">Professional Banking System</p>
            </div>
          </div>

          {/* Features — now conditional */}
          {!adminPortal && (
            <div className="space-y-8">
              <h2 className="text-3xl font-bold text-white mb-8">
                Modern Banking,<br />Simplified.
              </h2>

              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/10 backdrop-blur rounded-lg flex items-center justify-center flex-shrink-0">
                    <feature.icon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-primary-200 text-sm">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="text-primary-200 text-sm">
          <p>&copy; 2025 SecureBank. All rights reserved.</p>
          <p className="mt-1">Trusted by thousands of users worldwide.</p>
        </div>
      </div>

      {/* Right side - Auth Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-gray-50 dark:bg-dark-900">
        <div className="w-full max-w-md">
          {/* Mobile Logo */}
          <div className="flex lg:hidden items-center justify-center gap-3 mb-8">
            <div className="w-12 h-12 bg-primary-600 rounded-xl flex items-center justify-center">
              <DollarSign className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">SecureBank</h1>
            </div>
          </div>

          {/* Form Content */}
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default AuthLayout
